import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { useObjectMemo } from "../../../hooks";
import { useRequestWithFeedback } from "../../../composites/request/request.hooks";

import { API } from "./api";
import { actions as limitsActions } from "./slice";

export function useFetchAllLimitsRequest() {
  const { send, loading } = useRequestWithFeedback<API.Limits.Body>();

  const dispatch = useDispatch();

  const fetchAll = useCallback(() => {
    const onData = (data: API.Limits.Body) => {
      dispatch(limitsActions.receive(data));
    };
    send({
      action: API.fetchAll(),
      onData,
    });
  }, [dispatch, send]);

  return useObjectMemo({ loading, sendAll: fetchAll });
}
